import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedDate, injectIntl, FormattedTime } from 'react-intl';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as selectors from '../selectors';
import * as appSelectors from '../../app/selectors';
import * as userSelectors from '../../users/selectors';
import * as actions from '../actions';
import * as locationActions from '../../location/actions';
import * as locationSelectors from '../../location/selectors';
import configurationParameter from '../../configurationParameter';
import InternationalizationRender, { getInternationalization, PARAMETER_ASSOCIATED_FILES_TEXT, PARAMETER_ELEMENT_TEXT_PLURAL, PARAMETER_MY_ELEMENTS_TEXT } from '../../app/components/InternationalizationRender';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faImages, faEdit, faMapMarkerAlt, faTrashAlt, faChevronCircleDown, faChevronCircleUp,
    faSearch, faPlus, faFilter, faTimes, faLink, faInfoCircle, faUserPlus, faFileExport, faFileImport
} from '@fortawesome/free-solid-svg-icons'
import jQuery from 'jquery';
import { DeleteDialog } from '../../common';
import AddGeometricElementFile from './AddGeometricElementFile';
import GeometricElementFileGallery from './GeometricElementFileGallery';
import { Login, SignUp } from '../../users';
import GeometricElementsByGeometricElementTypeSearch from './GeometricElementsByGeometricElementTypeSearch';
import AddModifyGeometricElementRelation from './AddModifyGeometricElementRelation';
import GeometricElementFilesTable from './GeometricElementFilesTable';
import AddModifyGeometricElementJoin from './AddModifyGeometricElementJoin';
import { attributesFormatter, attributesColumnFormatter, attributesTooltipFormatter, capitalizeFirstLetter, initActionButtonTooltip, initValueTooltips, locationFormatter, locationTooltipFormatter } from '../../common/util';
import ConditionalColumnTableDisplay, { COLUMN_EXPAND_ROW, COLUMN_SHOW, COLUMN_TRUNCATE } from '../../common/components/ConditionalColumnTableDisplay';
import ExportGeometricElementsAsShapeConfirmation from './ExportGeometricElementsAsShapeConfirmation';
import ImportGeometricElementsFromShape from './ImportGeometricElementsFromShape';
import ClearGeometricElementType from './ClearGeometricElementType';

const mapStateToProps = function (state) {
    return ({
        authenticatedUser: userSelectors.getUser(state),
        listAllAttributes: selectors.getTotalAttributeType(state),
        allCodes: selectors.getAllCodes(state),
        language: appSelectors.getLanguage(state),
        activeLanguages: appSelectors.getActiveLanguages(state),
        geometricElementType: selectors.getGeometricElementType(state),
        geometricElements: selectors.getGeometricElementsByElementType(state),
        configurationParameters: configurationParameter.selectors.getTotalConfigurationParameters(state),
        provinces: locationSelectors.getProvinces(state),
        municipalities: locationSelectors.getMunicipalitiesByProvince(state),
        parishes: locationSelectors.getParishesByMunicipality(state)
    });
}

class GeometricElementsByElementType extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            authenticatedUser: null,
            isMyElementsPage: props.match.url.includes("myElements"),
            geometricElements: null,
            expandedRows: [],
            errorModalVisible: false,
            searchModalVisible: false,
            backendErrors: null,
            currentPage: 1,
            currentSize: 10,
            currentSortField: 'id',
            currentSortOrder: 'asc',
            deleteGeometricElementFileDialogShow: false,
            deleteGeometricElementFileName: "",
            deleteGeometricElementFileUuid: "",
            deleteGeometricElementDialogShow: false,
            deleteGeometricElementDescription: "",
            deleteGeometricElementId: "",
            addGeometricElementFileGeometricElement: null,
            addGeometricElementFileModalShow: false,
            geometricElementFileGalleryModalShow: false,
            geometricElementFileGalleryFiles: null,
            loginModalShow: false,
            signUpModalShow: false,
            geometricElementType: null,
            provinceNameFilter: "",
            municipalityNameFilter: "",
            parishNameFilter: "",
            relateGeometricElementsModalVisible: false,
            geometricElementToRelate: null,
            geometricElementRelationToModify: null,
            geometricElementJoinToModify: null,
            geometricElementToJoin: null,
            joinGeometricElementsModalVisible: false,
            showExportModalWindow: false,
            exportEmpty: false,
            showImportModalWindow: false,
            showEmptyModalWindow: false
        }
    }

    setLocationFiltersName = (province, municipality, parish) => {
        this.setState({
            provinceNameFilter: province,
            municipalityNameFilter: municipality,
            parishNameFilter: parish
        });
    }

    componentDidMount() {
        jQuery('#mainFooter').scrollTop(0);
        this.props.dispatch(actions.findGeometricElementTypeById(this.props.match.params.id, () => {
            this.setState({ geometricElementType: this.props.geometricElementType });
        }));

        this.props.dispatch(locationActions.findAllProvinces());
    }

    componentDidUpdate(prevProps) {
        if (this.props.allCodes && this.props.language) {

            jQuery('.modal-dialog').draggable({
                cursor: 'move',
                handle: '.modal-header'
            });

            if (this.state.geometricElements) {
                if (this.props.geometricElements !== this.state.geometricElements) {
                    this.setState({ geometricElements: this.props.geometricElements });
                }
            }

            if (prevProps.match.url !== this.props.match.url) {
                this.setState({ geometricElements: null, geometricElementType: null }, () => {
                    this.props.dispatch(actions.findGeometricElementTypeById(this.props.match.params.id, () => {
                        this.setState({ geometricElementType: this.props.geometricElementType });
                    }));
                });
            }

            if (this.props.authenticatedUser !== this.state.authenticatedUser) {
                this.setState({ authenticatedUser: this.props.authenticatedUser });
            }
        }

    }

    render() {

        let setBackendErrors = (backendErrors) => {
            this.setState({ backendErrors: backendErrors });
        }

        let RELATE_ELEMENTS_TO_PARISHES;
        let CAN_QUERY_GEOMETRIC_ELEMENTS;
        let canAddGeometricElement;
        let enableGeometricElementsRelation;
        let ATTRIBUTES_COLUMN_DISPLAY;
        let attributesColumDisplayOnTable;
        let LOCATION_COLUMN_DISPLAY;
        let locationColumDisplayOnTable;
        let canExportToShape;
        let canImportFromShape;

        if (this.props.configurationParameters) {

            RELATE_ELEMENTS_TO_PARISHES = this.props.configurationParameters.filter(
                configurationParameter => configurationParameter.code === "RELATE_ELEMENTS_TO_PARISHES");
            CAN_QUERY_GEOMETRIC_ELEMENTS = this.props.configurationParameters.filter(
                configurationParameter => configurationParameter.code === "ENABLE_GEOMETRIC_ELEMENT_QUERY");
            canAddGeometricElement = this.props.configurationParameters.filter(
                configurationParameter => configurationParameter.code === "ENABLE_GEOMETRIC_ELEMENT_INSERTION");
            enableGeometricElementsRelation = this.props.configurationParameters.filter(parameter =>
                parameter.code.indexOf("ENABLE_GEOMETRIC_ELEMENTS_RELATION") !== -1);
            ATTRIBUTES_COLUMN_DISPLAY = this.props.configurationParameters.filter(parameter =>
                parameter.code.indexOf("ATTRIBUTES_COLUMN_DISPLAY") !== -1)[0].value;
            attributesColumDisplayOnTable = [COLUMN_SHOW, COLUMN_TRUNCATE].includes(ATTRIBUTES_COLUMN_DISPLAY);
            LOCATION_COLUMN_DISPLAY = this.props.configurationParameters.filter(parameter =>
                parameter.code.indexOf("LOCATION_COLUMN_DISPLAY") !== -1)[0].value;
            canExportToShape = this.props.configurationParameters.filter(parameter =>
                parameter.code.indexOf("ENABLE_SHAPE_EXPORT_FOR_REGISTERED_USERS") !== -1);
            canImportFromShape = this.props.configurationParameters.filter(parameter =>
                parameter.code.indexOf("ENABLE_SHAPE_IMPORT_FOR_REGISTERED_USERS") !== -1);
            if (RELATE_ELEMENTS_TO_PARISHES.length > 0) {

                RELATE_ELEMENTS_TO_PARISHES = RELATE_ELEMENTS_TO_PARISHES[0].value;
                RELATE_ELEMENTS_TO_PARISHES = RELATE_ELEMENTS_TO_PARISHES === 'true';
                locationColumDisplayOnTable = [COLUMN_SHOW, COLUMN_TRUNCATE].includes(LOCATION_COLUMN_DISPLAY) && RELATE_ELEMENTS_TO_PARISHES;
            } else {

                RELATE_ELEMENTS_TO_PARISHES = false;
                locationColumDisplayOnTable = false;
            }
            if (canAddGeometricElement.length > 0) {

                canAddGeometricElement = canAddGeometricElement[0].value;
                canAddGeometricElement = (canAddGeometricElement === 'true');
            } else {

                canAddGeometricElement = false;
            }

            if (enableGeometricElementsRelation.length > 0) {

                enableGeometricElementsRelation = enableGeometricElementsRelation[0].value;
                enableGeometricElementsRelation = (enableGeometricElementsRelation === 'true') ||
                    (this.props.authenticatedUser && this.props.authenticatedUser.userRoleDto.code === "ADMIN");
            } else {

                enableGeometricElementsRelation = false;
            }
            if (canExportToShape.length > 0) {

                canExportToShape = canExportToShape[0].value;
                canExportToShape = this.state.authenticatedUser &&
                    ((canExportToShape === 'true' && this.state.isMyElementsPage) || this.state.authenticatedUser.userRoleDto.code === "ADMIN");
            } else {

                canExportToShape = false;
            }
            if (canImportFromShape.length > 0) {

                canImportFromShape = canImportFromShape[0].value;

                const isAdmin = this.state.authenticatedUser && this.state.authenticatedUser.userRoleDto.code === "ADMIN";

                let isAllowed = false;

                if (isAdmin) {

                    // Admins can only import from the general table.
                    isAllowed = !this.state.isMyElementsPage;
                } else {

                    // Users can only import in their elements table
                    // and only if they have the necessary permissions.
                    isAllowed =
                        this.state.isMyElementsPage &&
                        canImportFromShape === 'true' &&
                        canAddGeometricElement;
                }

                canImportFromShape = this.state.authenticatedUser && isAllowed;
            } else {

                canImportFromShape = false;
            }
        }

        let filterPanelRender = () => {
            let {
                sortField,
                sortOrder,
                geometricElementId,
                description,
                attributes,
                laterCreationDate,
                beforeCreationDate,
                laterModificationDate,
                beforeModificationDate,
                isPublic,
                isReviewed,
                internalComments,
                ownerLogin,
                province,
                municipality,
                parish
            } = this.state.geometricElements;

            let {
                provinceNameFilter,
                municipalityNameFilter,
                parishNameFilter
            } = this.state;

            if ((geometricElementId && geometricElementId !== "") || (description && description !== "")
                || (attributes && Object.keys(attributes).length > 0)
                || (laterCreationDate && laterCreationDate !== "") || (beforeCreationDate && beforeCreationDate !== "")
                || (laterModificationDate && laterModificationDate !== "") || (beforeModificationDate && beforeModificationDate !== "")
                || (
                    isPublic && isPublic !== "" && this.state.authenticatedUser &&
                    !(this.state.authenticatedUser.userRoleDto.code === "USER" && !this.state.isMyElementsPage))
                || (isReviewed && isReviewed !== "")
                || (internalComments && internalComments !== "") || (ownerLogin && ownerLogin !== "")
                || (province && province !== "") || (municipality && municipality !== "") || (parish && parish !== "")
            ) {

                return (
                    <div className="filtersPanel">
                        <span className="filterPanelTitle">
                            <FontAwesomeIcon icon={faFilter} />
                            &nbsp;
                            <FormattedMessage id="project.common.filters" />
                        </span>

                        <button id="clearFilters"
                            className="actionButton close filterPanelClear"
                            type="button"
                            data-toggle="tooltip"
                            data-placement="left"
                            title={this.props.intl.formatMessage({ id: "project.common.filters.clear" })}
                            onClick={() => {
                                let id = this.props.match.params.id;
                                if (this.state.authenticatedUser) {
                                    if (this.state.authenticatedUser.userRoleDto.code === "ADMIN") {
                                        if (this.state.isMyElementsPage) {
                                            this.props.dispatch(actions.findAdminGeometricElementsByElementTypeId(id, 0, 10, sortField, sortOrder, null,
                                                this.state.authenticatedUser.id, null, null, null, null, null, null, null, null, null, null,
                                                null, null, null, () => {
                                                    this.setState({ geometricElements: this.props.geometricElements });
                                                }));
                                        } else {
                                            this.props.dispatch(actions.findAdminGeometricElementsByElementTypeId(id, 0, 10, sortField, sortOrder, null,
                                                null, null, null, null, null, null, null, null, null, null, null, null,
                                                null, null, () => {
                                                    this.setState({ geometricElements: this.props.geometricElements });
                                                }))
                                        }
                                    }
                                    else {
                                        if (this.state.isMyElementsPage) {
                                            this.props.dispatch(actions.findUserGeometricElementsByElementTypeId(id, 0, 10, sortField, sortOrder, null,
                                                this.state.authenticatedUser.id, null, null, null, null, null, null, null, null,
                                                null, null, null, () => {
                                                    this.setState({ geometricElements: this.props.geometricElements });
                                                }));
                                        } else {
                                            this.props.dispatch(actions.findUserGeometricElementsByElementTypeId(id, 0, 10, sortField, sortOrder, true,
                                                null, null, null, null, null, null, null, null, null, null, null, null, () => {
                                                    this.setState({ geometricElements: this.props.geometricElements });
                                                }));
                                        }
                                    }

                                } else {
                                    this.props.dispatch(actions.findPublicGeometricElementsByElementTypeId(id, 0, 10, sortField, sortOrder, null, null,
                                        null, null, null, null, null, null, null, null, () => {
                                            this.setState({ geometricElements: this.props.geometricElements });
                                        }));
                                }
                            }}>
                            <FontAwesomeIcon icon={faTimes} size="sm" />
                        </button>

                        {
                            geometricElementId && geometricElementId !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        Id:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {geometricElementId}
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            description && description !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.description" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {description}
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            attributes && Object.keys(attributes).length > 0 ?
                                Object.keys(attributes).map(attribute => {

                                    if (attributes[attribute] !== "") {

                                        let filteredAttribute = Object.values(this.props.listAllAttributes).filter(attr => attr.id === Number(attribute));

                                        if (filteredAttribute.length) {

                                            filteredAttribute = filteredAttribute[0];

                                            return (
                                                <span className="filterPanelItem">
                                                    <span>
                                                        {
                                                            getInternationalization(this.props.language, filteredAttribute.code.code, this.props.allCodes, this.props.activeLanguages)
                                                        }:
                                                    </span>
                                                    &nbsp;
                                                    <span>
                                                        {
                                                            ["MULTISELECT", "SELECT"].includes(filteredAttribute.dataType) ?
                                                                getInternationalization(this.props.language, attributes[attribute], this.props.allCodes, this.props.activeLanguages)
                                                                :
                                                                ["BOOLEAN_CHECK", "BOOLEAN_SELECT"].includes(filteredAttribute.dataType) ?
                                                                    attributes[attribute] === "true" ? <FormattedMessage id="project.common.yes" /> : <FormattedMessage id="project.common.no" />
                                                                    :
                                                                    attributes[attribute]
                                                        }
                                                    </span>
                                                </span>
                                            )

                                        }

                                        return null;

                                    }

                                    return null;

                                })
                                : ""
                        }

                        {
                            province && province !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.common.location.province" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {provinceNameFilter}
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            municipality && municipality !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.common.location.municipality" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {municipalityNameFilter}
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            parish && parish !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.common.location.parish" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {parishNameFilter}
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            laterCreationDate && laterCreationDate !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.moreCreationDate" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        <FormattedDate value={laterCreationDate} />
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            beforeCreationDate && beforeCreationDate !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.lessCreationDate" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        <FormattedDate value={beforeCreationDate} />
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            laterModificationDate && laterModificationDate !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.moreModificationDate" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        <FormattedDate value={laterModificationDate} />
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            beforeModificationDate && beforeModificationDate !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.lessModificationDate" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        <FormattedDate value={beforeModificationDate} />
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            isPublic && isPublic !== "" && this.state.authenticatedUser
                                && this.state.authenticatedUser &&
                                !(this.state.authenticatedUser.userRoleDto.code === "USER" && !this.state.isMyElementsPage)
                                ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.isPublic" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {isPublic === "true"
                                            ?
                                            <FormattedMessage id="project.common.yes" />
                                            :
                                            <FormattedMessage id="project.common.no" />
                                        }
                                    </span>
                                </span>
                                :
                                ""
                        }

                        {
                            isReviewed && isReviewed !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.isReviewed" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {this.state.geometricElements.isReviewed &&
                                            this.state.geometricElements.isReviewed === "true" ?
                                            <FormattedMessage id="project.common.yes" />
                                            :
                                            <FormattedMessage id="project.common.no" />}
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            internalComments && internalComments !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.internalComments" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {this.state.geometricElements.internalComments}
                                    </span>
                                </span>
                                : ""
                        }

                        {
                            ownerLogin && ownerLogin !== "" ?
                                <span className="filterPanelItem">
                                    <span>
                                        <FormattedMessage id="project.elements.owner" />:
                                    </span>
                                    &nbsp;
                                    <span>
                                        {this.state.geometricElements.ownerLogin}
                                    </span>
                                </span>
                                : ""
                        }

                    </div>
                );
            } else {
                return null
            }
        }

        let listAttributes;

        if (this.state.geometricElementType)
            listAttributes = this.state.geometricElementType.listAttributeType;

        let handleBtnClick = (row) => {
            if (!this.state.expandedRows.includes(row.id)) {
                this.setState({ expandedRows: [row.id] });
            } else {
                this.setState({ expandedRows: [] });
            }
        }

        if (this.state.geometricElementType && listAttributes && this.props.allCodes &&
            (CAN_QUERY_GEOMETRIC_ELEMENTS ||
                (this.state.authenticatedUser && this.state.authenticatedUser.userRoleDto.code === "ADMIN"))
        ) {

            let handleTableChange = (page, sizePerPage, sortField, sortOrder) => {
                let pageToSearch = page > 0 ? page - 1 : 0;
                if (!this.state.geometricElements) {
                    if (this.state.authenticatedUser) {
                        if (this.state.authenticatedUser.userRoleDto.code === "ADMIN") {
                            if (this.state.isMyElementsPage) {
                                this.props.dispatch(actions.findAdminGeometricElementsByElementTypeId(
                                    this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                                    sortOrder, null, this.state.authenticatedUser.id,
                                    null, null, null, null, null, null, null, null, null, null, null,
                                    null, null, () => {
                                        this.setState({ geometricElements: this.props.geometricElements });
                                    }));
                            } else {
                                this.props.dispatch(actions.findAdminGeometricElementsByElementTypeId(
                                    this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                                    sortOrder, null, null, null, null, null, null, null, null, null, null, null, null, null,
                                    null, null, () => {
                                        this.setState({ geometricElements: this.props.geometricElements });
                                    }));
                            }
                        }
                        else {
                            if (this.state.isMyElementsPage) {
                                this.props.dispatch(actions.findUserGeometricElementsByElementTypeId(
                                    this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                                    sortOrder, null, this.state.authenticatedUser.id, null, null, null, null,
                                    null, null, null, null, null, null, null, () => {
                                        this.setState({ geometricElements: this.props.geometricElements });
                                    }));
                            } else {
                                this.props.dispatch(actions.findUserGeometricElementsByElementTypeId(
                                    this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                                    sortOrder, true, null, null, null, null, null, null, null, null, null, null,
                                    null, null, () => {
                                        this.setState({ geometricElements: this.props.geometricElements });
                                    }));
                            }
                        }
                    } else {
                        this.props.dispatch(actions.findPublicGeometricElementsByElementTypeId(
                            this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                            sortOrder, null, null, null, null, null, null, null, null, null, null,
                            () => {
                                this.setState({ geometricElements: this.props.geometricElements });
                            }));
                    }
                } else {
                    if (this.state.authenticatedUser) {
                        if (this.state.authenticatedUser.userRoleDto.code === "ADMIN") {
                            if (this.state.isMyElementsPage) {
                                this.props.dispatch(actions.findAdminGeometricElementsByElementTypeId(
                                    this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                                    sortOrder, this.state.geometricElements.isPublic, this.state.authenticatedUser.id,
                                    this.state.geometricElements.geometricElementId, this.state.geometricElements.description,
                                    this.state.geometricElements.beforeCreationDate, this.state.geometricElements.laterCreationDate,
                                    this.state.geometricElements.beforeModificationDate, this.state.geometricElements.laterModificationDate,
                                    this.state.geometricElements.isReviewed, this.state.geometricElements.internalComments,
                                    null, this.state.geometricElements.attributes, this.state.geometricElements.province,
                                    this.state.geometricElements.municipality, this.state.geometricElements.parish, () => {
                                        this.setState({ geometricElements: this.props.geometricElements })
                                    }));
                            } else {
                                this.props.dispatch(actions.findAdminGeometricElementsByElementTypeId(
                                    this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                                    sortOrder, this.state.geometricElements.isPublic, null, this.state.geometricElements.geometricElementId,
                                    this.state.geometricElements.description, this.state.geometricElements.beforeCreationDate,
                                    this.state.geometricElements.laterCreationDate, this.state.geometricElements.beforeModificationDate,
                                    this.state.geometricElements.laterModificationDate, this.state.geometricElements.isReviewed,
                                    this.state.geometricElements.internalComments, this.state.geometricElements.ownerLogin,
                                    this.state.geometricElements.attributes, this.state.geometricElements.province,
                                    this.state.geometricElements.municipality, this.state.geometricElements.parish, () => {
                                        this.setState({ geometricElements: this.props.geometricElements })
                                    }));
                            }
                        }
                        else {
                            if (this.state.isMyElementsPage) {
                                this.props.dispatch(actions.findUserGeometricElementsByElementTypeId(
                                    this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                                    sortOrder, this.state.geometricElements.isPublic, this.state.authenticatedUser.id, this.state.geometricElements.geometricElementId, this.state.geometricElements.description,
                                    this.state.geometricElements.beforeCreationDate, this.state.geometricElements.laterCreationDate,
                                    this.state.geometricElements.beforeModificationDate, this.state.geometricElements.laterModificationDate,
                                    this.state.geometricElements.isReviewed, this.state.geometricElements.attributes,
                                    this.state.geometricElements.province, this.state.geometricElements.municipality,
                                    this.state.geometricElements.parish, () => {
                                        this.setState({ geometricElements: this.props.geometricElements })
                                    }));
                            } else {
                                this.props.dispatch(actions.findUserGeometricElementsByElementTypeId(
                                    this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                                    sortOrder, true, null, this.state.geometricElements.geometricElementId, this.state.geometricElements.description,
                                    this.state.geometricElements.beforeCreationDate, this.state.geometricElements.laterCreationDate,
                                    this.state.geometricElements.beforeModificationDate, this.state.geometricElements.laterModificationDate,
                                    this.state.geometricElements.isReviewed, this.state.geometricElements.attributes,
                                    this.state.geometricElements.province, this.state.geometricElements.municipality,
                                    this.state.geometricElements.parish, () => {
                                        this.setState({ geometricElements: this.props.geometricElements })
                                    }));
                            }
                        }
                    } else {
                        this.props.dispatch(actions.findPublicGeometricElementsByElementTypeId(
                            this.props.match.params.id, pageToSearch, sizePerPage, sortField,
                            sortOrder, this.state.geometricElements.geometricElementId, this.state.geometricElements.description,
                            this.state.geometricElements.beforeCreationDate, this.state.geometricElements.laterCreationDate,
                            this.state.geometricElements.beforeModificationDate, this.state.geometricElements.laterModificationDate,
                            this.state.geometricElements.attributes, this.state.geometricElements.province,
                            this.state.geometricElements.municipality, this.state.geometricElements.parish, () => {
                                this.setState({ geometricElements: this.props.geometricElements })
                            }));
                    }
                }
                this.setState({
                    currentPage: page,
                    sizePerPage: sizePerPage,
                    currentSortField: sortField,
                    currentSortOrder: sortOrder
                })
            }

            initValueTooltips();
            initActionButtonTooltip();

            const expandRow = {
                renderer: row => (
                    <>
                        {ATTRIBUTES_COLUMN_DISPLAY === COLUMN_EXPAND_ROW && row.listAttributeValueDto.length > 0 &&
                            <div className="card mb-3">
                                <h5 className="card-header text-left">
                                    <FormattedMessage id="project.common.attributes" />
                                </h5>
                                <div className="card-body">
                                    <div className="row row-cols-md-1 row-cols-md-2 row-cols-md-3 row-cols-md-4 row-cols-md-5 row-cols-md-6 card-block">
                                        {attributesColumnFormatter(row.listAttributeValueDto)}
                                    </div>
                                </div>
                            </div>
                        }
                        {LOCATION_COLUMN_DISPLAY === COLUMN_EXPAND_ROW && RELATE_ELEMENTS_TO_PARISHES &&
                            <div className="card mb-3">
                                <h5 className="card-header text-left">
                                    <FormattedMessage id="project.common.location" />
                                </h5>
                                <div className="card-body">
                                    {locationFormatter(row.listParishes, false, true)}
                                </div>
                            </div>
                        }
                        <GeometricElementFilesTable
                            files={row.listGeometricElementFileDto.map((elementFile) =>
                                ({ ...elementFile, owner: row.owner, isPublic: row.isPublic, id: row.id }))}
                            geometricElement={row}
                            handleOpenAddGeometricElementFile={() => {
                                this.setState({
                                    addGeometricElementFileGeometricElement: row,
                                    addGeometricElementFileModalShow: true
                                })
                            }}
                            handleOpenDeleteGeometricElementFile={(originalFilename, uuid) => {
                                this.setState({
                                    deleteGeometricElementFileDialogShow: true,
                                    deleteGeometricElementFileName: originalFilename,
                                    deleteGeometricElementFileUuid: uuid
                                });
                            }}
                        />
                    </>
                ),
                expanded: this.state.expandedRows,
                expandByColumnOnly: true
            }

            const columns = [{
                dataField: 'id',
                text: 'Id',
                sort: true,
                headerAlign: 'left'
            }, {
                dataField: 'description',
                text: this.props.intl.formatMessage({ id: "project.elements.description" }),
                headerAlign: 'left',
                sort: true,
                formatter: (cell, row) => (
                    cell ?
                        cell
                        : "-"
                )
            }, {
                dataField: 'creationDate',
                text: this.props.intl.formatMessage({ id: "project.elements.creationDate" }),
                headerAlign: 'left',
                sort: true,
                formatter: (cellContent, row) => (
                    <span>
                        <FormattedDate
                            value={cellContent}
                            day="numeric"
                            month="numeric"
                            year="numeric"
                        />&nbsp;
                        <FormattedTime
                            value={cellContent}
                        />
                    </span>
                )
            }, {
                dataField: 'modificationDate',
                text: this.props.intl.formatMessage({ id: "project.elements.modificationDate" }),
                headerAlign: 'left',
                sort: true,
                formatter: (cellContent, row) => (
                    <span>
                        <FormattedDate
                            value={cellContent}
                            day="numeric"
                            month="numeric"
                            year="numeric"
                        />&nbsp;
                        <FormattedTime
                            value={cellContent}
                        />
                    </span>
                )
            }, {
                dataField: 'action',
                isDummyField: true,
                text: this.props.intl.formatMessage({ id: "project.common.action" }),
                headerAlign: 'left',
                formatExtraData: this.state.expandedRows,
                formatter: (cellContent, row, rowIndex, formatExtraData) => (
                    <div className="text-left">
                        <span
                            onClick={() => {
                                this.props.history.push({
                                    pathname: `/geometric_element/details/${row.id}`,
                                    state: {
                                        centerFeature: row
                                    }
                                })
                            }}
                            className="actionButton btn-link"
                            style={{
                                cursor: "pointer",
                                marginLeft: "0.5em"
                            }}
                            id={"showGeometricElementDetails" + row.id}
                            data-toggle="tooltip"
                            data-placement="left"
                            title={this.props.intl.formatMessage({ id: "project.common.showDetails" })}
                        >
                            <FontAwesomeIcon icon={faInfoCircle} />
                        </span>
                        {row.listGeometricElementFileDto && row.listGeometricElementFileDto.filter(file => file.contentType.startsWith("image/")).length ?
                            <span id={"viewPhotosGallery" + row.id}
                                className="actionButton btn-link"
                                onClick={() =>
                                    this.setState({
                                        geometricElementFileGalleryModalShow: true,
                                        geometricElementFileGalleryFiles: row.listGeometricElementFileDto
                                    })
                                }
                                style={{
                                    cursor: "pointer",
                                    marginLeft: "0.5em"
                                }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={this.props.intl.formatMessage({ id: "project.common.viewFiles" })}
                            >
                                <FontAwesomeIcon icon={faImages} />
                            </span> : ""}
                        <span id={"centerGeometricElementOnViewer" + row.id}
                            onClick={() => {
                                this.props.history.push({ pathname: "/", state: { centerFeature: row } })
                            }}
                            className="actionButton btn-link"
                            style={{
                                cursor: "pointer",
                                marginLeft: "0.5em"
                            }}
                            data-toggle="tooltip"
                            data-placement="left"
                            title={this.props.intl.formatMessage({ id: "project.common.centerOnViewer" })}
                        >
                            <FontAwesomeIcon icon={faMapMarkerAlt} />
                        </span>
                        {this.state.authenticatedUser ?
                            this.state.authenticatedUser.userRoleDto.code === "ADMIN" ||
                                (row.isOwnerUser) ?
                                <span id={"modifyGeometricElementOnViewer" + row.id}
                                    onClick={() => {
                                        this.props.history.push({ pathname: "/", state: { featureToModify: row } })
                                    }}
                                    className="actionButton btn-link"
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "0.5em"
                                    }}
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    title={this.props.intl.formatMessage({ id: "project.common.modify" })}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </span> : "" : ""

                        }
                        {this.state.authenticatedUser ?
                            this.state.authenticatedUser.userRoleDto.code === "ADMIN" ||
                                (row.isOwnerUser) ?
                                <span id={"deleteGeometricElement" + row.id}
                                    onClick={() =>
                                        this.setState({
                                            deleteGeometricElementDialogShow: true,
                                            deleteGeometricElementDescription: row.description,
                                            deleteGeometricElementId: row.id
                                        })
                                    }
                                    className="actionButton btn-link"
                                    style={{
                                        cursor: "pointer",
                                        marginLeft: "0.5em"
                                    }}
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    title={this.props.intl.formatMessage({ id: "project.common.delete" })}
                                >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </span>
                                :
                                ""
                            : ""
                        }
                        {enableGeometricElementsRelation &&
                            <span id={"relateGeometricElement" + row.id}
                                onClick={() => {
                                    this.setState({
                                        geometricElementRelationToModify: null,
                                        geometricElementToRelate: row,
                                        relateGeometricElementsModalVisible: true,
                                        backendErrors: null
                                    });
                                }}
                                className="actionButton btn-link"
                                style={{
                                    cursor: "pointer",
                                    marginLeft: "0.5em"
                                }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={this.props.intl.formatMessage({ id: "project.elements.relations.relate" }, {
                                    plural: getInternationalization(this.props.language, PARAMETER_ELEMENT_TEXT_PLURAL, this.props.allCodes, this.props.activeLanguages)
                                })}
                            >
                                <FontAwesomeIcon icon={faLink} />
                            </span>
                        }
                        {row.userCanJoin &&
                            <span id={"joinGeometricElement" + row.id}
                                onClick={() => {
                                    this.setState({
                                        geometricElementJoinToModify: null,
                                        geometricElementToJoin: row,
                                        joinGeometricElementsModalVisible: true,
                                        backendErrors: null
                                    });
                                }}
                                className="actionButton btn-link"
                                style={{
                                    cursor: "pointer",
                                    marginLeft: "0.5em"
                                }}
                                data-toggle="tooltip"
                                data-placement="left"
                                title={getInternationalization(this.props.language, this.state.geometricElementType.joinTooltipText, this.props.allCodes, this.props.activeLanguages)}
                            >
                                <FontAwesomeIcon icon={faUserPlus} />
                            </span>
                        }
                        <span id={"expandRowButton" + row.id}
                            onClick={() => handleBtnClick(row)}
                            className="actionButton btn-link"
                            style={{
                                cursor: "pointer",
                                marginLeft: "0.5em"
                            }}
                            data-toggle="tooltip"
                            data-placement="left"
                            data-original-title={this.props.intl.formatMessage({
                                id: !formatExtraData.includes(row.id) ?
                                    "project.common.expandRow" : "project.common.collapseRow"
                            })}
                        >
                            <FontAwesomeIcon icon={!formatExtraData.includes(row.id) ? faChevronCircleDown : faChevronCircleUp} />
                        </span>
                    </div>
                )
            },
            ];

            if (attributesColumDisplayOnTable) {

                columns.splice(2, 0, {
                    dataField: 'atributes',
                    isDummyField: true,
                    text: this.props.intl.formatMessage({ id: "project.common.attributes" }),
                    headerAlign: 'left',
                    formatter: (cellContent, row) => (

                        <ConditionalColumnTableDisplay
                            key={this.props.language}
                            parameter={ATTRIBUTES_COLUMN_DISPLAY}
                            formatter={(truncate) => attributesFormatter(row, truncate)}
                            tooltipFormatter={() => attributesTooltipFormatter(row, this.props)}
                        />
                    )
                });
            }

            if (locationColumDisplayOnTable) {
                columns.splice(3, 0, {
                    dataField: 'listParishes',
                    text: this.props.intl.formatMessage({ id: 'project.common.location' }),
                    headerAlign: 'left',
                    formatter: (cellContent, row) => (

                        <ConditionalColumnTableDisplay
                            key={this.props.language}
                            parameter={LOCATION_COLUMN_DISPLAY}
                            formatter={(truncate) => locationFormatter(cellContent, truncate)}
                            tooltipFormatter={() => locationTooltipFormatter(cellContent)}
                        />
                    )
                })
            }

            if (this.state.authenticatedUser) {
                columns.splice(locationColumDisplayOnTable ? attributesColumDisplayOnTable ? 6 : 5 : 4, 0, {
                    dataField: 'isPublic',
                    text: this.props.intl.formatMessage({ id: "project.elements.isPublic" }),
                    headerAlign: 'left',
                    sort: true,
                    formatter: (cellContent, row) => (
                        cellContent ? <span><FormattedMessage id="project.common.yes" /></span> :
                            <span><FormattedMessage id="project.common.no" /></span>
                    )
                });

                columns.splice(locationColumDisplayOnTable ? attributesColumDisplayOnTable ? 7 : 6 : 5, 0, {
                    dataField: 'isReviewed',
                    text: this.props.intl.formatMessage({ id: "project.elements.isReviewed" }),
                    headerAlign: 'left',
                    sort: true,
                    formatter: (cellContent, row) => (
                        cellContent ? <span><FormattedMessage id="project.common.yes" /></span> :
                            <span><FormattedMessage id="project.common.no" /></span>
                    )
                });

                if (this.state.authenticatedUser.userRoleDto.code === "ADMIN") {
                    columns.splice(locationColumDisplayOnTable ? attributesColumDisplayOnTable ? 8 : 7 : 6, 0, {
                        dataField: 'geom',
                        text: this.props.intl.formatMessage({ id: "project.elements.geom" }),
                        headerAlign: 'left',
                        formatter: (cellContent, row) => (
                            cellContent ?
                                <span>{<FormattedMessage id={"project.elements.geom." + cellContent.type} />}</span> : ""
                        )
                    });
                    columns.splice(locationColumDisplayOnTable ? attributesColumDisplayOnTable ? 9 : 8 : 7, 0, {
                        dataField: 'internalComments',
                        text: this.props.intl.formatMessage({ id: "project.elements.internalComments" }),
                        headerAlign: 'left',
                        sort: true,
                        formatter: (cellContent, row) => (
                            cellContent ? cellContent : "-"
                        )
                    });
                    if (!this.state.isMyElementsPage)
                        columns.splice(locationColumDisplayOnTable ? attributesColumDisplayOnTable ? 10 : 9 : 8, 0, {
                            dataField: 'owner.login',
                            text: this.props.intl.formatMessage({ id: "project.elements.owner" }),
                            headerAlign: 'left'
                        });
                }
            }

            let getOpenlayersGeometryType = (geometryType) => {

                if (geometryType === "POINT") {

                    return "Point";

                }

                if (geometryType === "LINE") {

                    return "LineString";

                }

                if (geometryType === "POLYGON") {

                    return "Polygon";

                }

            }

            let renderDropdown = () => {
                if (this.state.geometricElementType.geometryType === "ANY_GEOMETRY" ||
                    this.state.geometricElementType.geometryType === "POINT_POLYGON" ||
                    this.state.geometricElementType.geometryType === "POINT_LINE" ||
                    this.state.geometricElementType.geometryType === "LINE_POLYGON") {

                    return (
                        <div className="dropdown float-right mb-2">
                            <a className="btn btn-primary dropdown-toggle" href="." role="button" id="addGeometricElementDropdownLink"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            >
                                <FontAwesomeIcon icon={faPlus} />
                                &nbsp;
                                <FormattedMessage
                                    id="project.elements.new"
                                    values={{
                                        element: getInternationalization(
                                            this.props.language,
                                            this.state.geometricElementType.code,
                                            this.props.allCodes,
                                            this.props.activeLanguages
                                        ).toLocaleLowerCase()
                                    }}
                                />
                            </a>

                            <div className="dropdown-menu" aria-labelledby="addGeometricElementDropdownLink">
                                {(this.state.geometricElementType.geometryType.includes("POINT") ||
                                    this.state.geometricElementType.geometryType === "ANY_GEOMETRY") &&
                                    <Link className="dropdown-item"
                                        to={{
                                            pathname: "/createElement",
                                            search: `typeId=${this.state.geometricElementType.id}&geometryType=Point`
                                        }}
                                        key={this.state.geometricElementType.id + '-Point'}
                                        id={this.state.geometricElementType.id + '-Point'}
                                    >
                                        <FormattedMessage id="project.elements.geom.Point" />
                                    </Link>
                                }
                                {(this.state.geometricElementType.geometryType.includes("LINE") ||
                                    this.state.geometricElementType.geometryType === "ANY_GEOMETRY") &&
                                    <Link className="dropdown-item"
                                        to={{
                                            pathname: "/createElement",
                                            search: `typeId=${this.state.geometricElementType.id}&geometryType=Line`
                                        }}
                                        key={this.state.geometricElementType.id + '-LineString'}
                                        id={this.state.geometricElementType.id + '-LineString'}
                                    >
                                        <FormattedMessage id="project.elements.geom.LineString" />
                                    </Link>
                                }
                                {(this.state.geometricElementType.geometryType.includes("POLYGON") ||
                                    this.state.geometricElementType.geometryType === "ANY_GEOMETRY") &&
                                    <Link className="dropdown-item"
                                        to={{
                                            pathname: "/createElement",
                                            search: `typeId=${this.state.geometricElementType.id}&geometryType=Polygon`
                                        }}
                                        key={this.state.geometricElementType.id + '-Polygon'}
                                        id={this.state.geometricElementType.id + '-Polygon'}
                                    >
                                        <FormattedMessage id="project.elements.geom.Polygon" />
                                    </Link>
                                }
                            </div>
                        </div>
                    );

                } else {

                    return (

                        <Link className="btn btn-primary float-right"
                            to={{
                                pathname: "/createElement",
                                search: `typeId=${this.state.geometricElementType.id}&geometryType${getOpenlayersGeometryType(this.state.geometricElementType.geometryType)}`
                            }}
                            key={`${this.state.geometricElementType.id}-${getOpenlayersGeometryType(this.state.geometricElementType.geometryType)}`}
                            id={`${this.state.geometricElementType.id}-${getOpenlayersGeometryType(this.state.geometricElementType.geometryType)}`}
                        >
                            <FontAwesomeIcon icon={faPlus} />
                            &nbsp;
                            <FormattedMessage
                                id="project.elements.new"
                                values={{
                                    element: getInternationalization(
                                        this.props.language,
                                        this.state.geometricElementType.code,
                                        this.props.allCodes,
                                        this.props.activeLanguages
                                    ).toLocaleLowerCase()
                                }}
                            />
                        </Link>

                    )

                }

            }

            return (
                <div className="card card-body">

                    {this.state.authenticatedUser &&
                        this.state.authenticatedUser.userRoleDto.code === "USER" &&
                        !this.state.isMyElementsPage ?
                        <div className="alert alert-primary text-left">
                            <FormattedMessage id="project.elements.myElements.message"
                                values={{
                                    plural: <InternationalizationRender value={PARAMETER_ELEMENT_TEXT_PLURAL} />
                                }}
                            />
                        </div>
                        : ""
                    }

                    {!this.state.authenticatedUser ?
                        <div className="alert alert-primary text-left">
                            <FormattedMessage id="project.elements.anonymous.message"
                                values={{
                                    link: <span className="btn-link alert-link"
                                        onClick={() =>
                                            this.setState({
                                                backendErrors: null,
                                                loginModalShow: true
                                            })
                                        }
                                        style={{ cursor: 'pointer' }}
                                        id={"loginFromTable"}
                                    >
                                        <FormattedMessage id="project.app.Header.login" />
                                    </span>,
                                    plural: <InternationalizationRender value={PARAMETER_ELEMENT_TEXT_PLURAL} />
                                }}
                            />
                        </div>
                        : ""
                    }

                    <h3>
                        {this.state.isMyElementsPage &&
                            <>
                                <FormattedMessage id="project.app.Header.myContributions" values={{
                                    myElements: capitalizeFirstLetter(getInternationalization(this.props.language, PARAMETER_MY_ELEMENTS_TEXT, this.props.allCodes, this.props.activeLanguages))
                                }} /> - </>}<InternationalizationRender value={this.state.geometricElementType.code} />
                    </h3>

                    {/* Action buttons */}
                    <div id="actionButtons" className="text-right">
                        {this.state.authenticatedUser && (canAddGeometricElement || this.state.authenticatedUser.userRoleDto.code === "ADMIN") &&
                            renderDropdown()}
                        {canExportToShape &&
                            <>
                                <button id="exportGeometricElements" className="btn btn-primary float-right mr-2 mb-2" onClick={() => {
                                    this.setState({ showExportModalWindow: true, exportEmpty: false })
                                }}>
                                    <FontAwesomeIcon icon={faFileExport} />
                                    &nbsp;
                                    <FormattedMessage id="project.elements.export.button" />
                                </button>
                                <button id="exportGeometricElements" className="btn btn-primary float-right mr-2 mb-2" onClick={() => {
                                    this.setState({ showExportModalWindow: true, exportEmpty: true })
                                }}>
                                    <FontAwesomeIcon icon={faFileExport} />
                                    &nbsp;
                                    <FormattedMessage id="project.elements.export.model.button" />
                                </button>
                            </>}
                        {canImportFromShape &&
                            <button id="importGeometricElements" className="btn btn-primary float-right mr-2 mb-2" onClick={() => {
                                this.setState({ showImportModalWindow: true })
                            }}>
                                <FontAwesomeIcon icon={faFileImport} />
                                &nbsp;
                                <FormattedMessage id="project.elements.import.button" />
                            </button>}
                        {this.state.authenticatedUser?.userRoleDto?.code === "ADMIN" &&
                            <button id="exportGeometricElements" className="btn btn-primary float-right mr-2 mb-2" onClick={() => {
                                this.setState({ showEmptyModalWindow: true })
                            }}>
                                <FontAwesomeIcon icon={faTrashAlt} />
                                &nbsp;
                                <FormattedMessage id="project.elements.clear.button" />
                            </button>}
                        <button id="searchGeometricElements" className="btn btn-primary float-right mr-2 mb-2" onClick={() => {
                            this.setState({ searchModalVisible: true });
                        }}>
                            <FontAwesomeIcon icon={faSearch} />
                            &nbsp;
                            <FormattedMessage id="project.app.Body.search" />
                        </button>
                    </div>

                    {/* Relate geometric elements dialog */}
                    <AddModifyGeometricElementRelation
                        modalShow={this.state.relateGeometricElementsModalVisible}
                        geometricElement={this.state.geometricElementToRelate}
                        handleSubmit={() => {
                            this.setState({ relateGeometricElementsModalVisible: false });
                            this.props.history.push({
                                pathname: "/geometric_element/details/" + this.state.geometricElementToRelate.id,
                                state: {
                                    scrollToRelations: true,
                                    scrolltoJoins: false
                                }
                            });
                        }}
                        geometricElementRelationToModify={this.state.geometricElementRelationToModify}
                        backendErrors={this.state.backendErrors}
                        setBackendErrors={setBackendErrors}
                        hideModalWindow={() => this.setState({ relateGeometricElementsModalVisible: false })}
                    />

                    {/* Join geometric elements dialog */}
                    {this.props.geometricElementType.canJoin &&
                        <AddModifyGeometricElementJoin
                            modalShow={this.state.joinGeometricElementsModalVisible}
                            geometricElement={this.state.geometricElementToJoin}
                            handleSubmit={() => {
                                this.setState({ joinGeometricElementsModalVisible: false });
                                this.props.history.push({
                                    pathname: "/geometric_element/details/" + this.state.geometricElementToJoin.id,
                                    state: {
                                        scrollToRelations: false,
                                        scrollToJoins: true
                                    }
                                });
                            }}
                            geometricElementJoinToModify={this.state.geometricElementJoinToModify}
                            backendErrors={this.state.backendErrors}
                            setBackendErrors={setBackendErrors}
                            hideModalWindow={() => this.setState({ joinGeometricElementsModalVisible: false })}
                        />
                    }

                    {/* Search dialog */}
                    <GeometricElementsByGeometricElementTypeSearch
                        modalShow={this.state.searchModalVisible}
                        currentPage={1}
                        currentSize={this.state.currentSize}
                        currentSortField={this.state.currentSortField}
                        currentSortOrder={this.state.currentSortOrder}
                        listAttributes={this.state.geometricElementType.listAttributeType}
                        hideModalWindow={() => this.setState({ searchModalVisible: false })}
                        moveToFirstPage={() => this.setState({ currentPage: 1 })}
                        setLocationFiltersName={this.setLocationFiltersName}
                    />

                    {/* Login/SignUp dialog */}
                    <Login
                        modalShow={this.state.loginModalShow}
                        createElement={null}
                        backendErrors={this.state.backendErrors}
                        setBackendErrors={setBackendErrors}
                        hideModalWindow={() => this.setState({ loginModalShow: false })}
                        handleOpenSignUpModalWindow={() => {
                            this.setState({
                                backendErrors: null,
                                loginModalShow: false,
                                signUpModalShow: true
                            });
                        }}
                    />
                    <SignUp
                        modalShow={this.state.signUpModalShow}
                        backendErrors={this.state.backendErrors}
                        createElement={null}
                        handleAddNewUser={null}
                        setBackendErrors={setBackendErrors}
                        hideModalWindow={() => this.setState({ signUpModalShow: false })}
                    />

                    {/* View photos gallery dialog */}
                    <GeometricElementFileGallery
                        modalShow={this.state.geometricElementFileGalleryModalShow}
                        geometricElementFiles={this.state.geometricElementFileGalleryFiles}
                        hideModalWindow={() => this.setState({ geometricElementFileGalleryModalShow: false })}
                    />

                    {/* Delete geometric element dialog */}
                    <DeleteDialog
                        modalShow={this.state.deleteGeometricElementDialogShow}
                        title={this.props.intl.formatMessage({ id: 'project.common.delete' })}
                        details={
                            this.props.intl.formatMessage(
                                { id: 'project.elements.geometricElement.delete.message' },
                                {
                                    element: <b>{this.state.deleteGeometricElementDescription}</b>,
                                    alert: <div class="alert alert-primary" role="alert">
                                        <FormattedMessage id="project.elements.geometricElement.delete.message.alert" values={{
                                            files: getInternationalization(this.props.language, PARAMETER_ASSOCIATED_FILES_TEXT,
                                                this.props.allCodes, this.props.activeLanguages)
                                        }} />
                                    </div>
                                })
                        }
                        backendErrors={this.state.backendErrors}
                        hideModalWindow={() => { this.setState({ deleteGeometricElementDialogShow: false }) }}
                        handleSubmit={() => {
                            this.props.dispatch(actions.deleteGeometricElement(this.state.deleteGeometricElementId,
                                () => {
                                    let currentPage = this.state.currentPage;
                                    if (this.state.geometricElements.result.items.length === 1 && this.state.currentPage > 0) {
                                        currentPage = currentPage - 1;
                                    }
                                    handleTableChange(currentPage, this.state.currentSize,
                                        this.state.currentSortField, this.state.currentSortOrder);
                                    this.setState({ deleteGeometricElementDialogShow: false });
                                },
                                (error) => {
                                    setBackendErrors(error);
                                }))
                        }}
                        setBackendErrors={setBackendErrors}
                    />

                    {/* Delete geometric element dialog */}
                    <ClearGeometricElementType
                        geometricElementType={this.state.geometricElementType}
                        modalShow={this.state.showEmptyModalWindow}
                        backendErrors={this.state.backendErrors}
                        hideModalWindow={() => { this.setState({ showEmptyModalWindow: false }) }}
                        handleSubmit={() => {

                            let currentPage = this.state.currentPage;
                            if (this.state.geometricElements.result.items.length === 1 && this.state.currentPage > 0) {

                                currentPage = currentPage - 1;
                            }
                            handleTableChange(currentPage, this.state.currentSize,
                                this.state.currentSortField, this.state.currentSortOrder);
                            this.setState({ showEmptyModalWindow: false });
                        }}
                        setBackendErrors={setBackendErrors}
                    />

                    {/* Add geometric element file dialog */}
                    <AddGeometricElementFile
                        modalShow={this.state.addGeometricElementFileModalShow}
                        geometricElement={this.state.addGeometricElementFileGeometricElement}
                        handleSubmit={() => {
                            handleTableChange(this.state.currentPage, this.state.currentSize,
                                this.state.currentSortField, this.state.currentSortOrder);
                            this.setState({ addGeometricElementFileModalShow: false });
                        }}
                        hideModalWindow={() => this.setState({ addGeometricElementFileModalShow: false })}
                    />

                    {/*Delete geometric element file dialog*/}
                    <DeleteDialog
                        modalShow={this.state.deleteGeometricElementFileDialogShow}
                        title={this.props.intl.formatMessage({ id: 'project.common.deleteFile' })}
                        details={this.props.intl.formatMessage(
                            { id: 'project.elements.delete.message' }, { element: <b>{this.state.deleteGeometricElementFileName}</b> })}
                        backendErrors={this.state.backendErrors}
                        hideModalWindow={() => { this.setState({ deleteGeometricElementFileDialogShow: false }) }}
                        handleSubmit={() => {
                            this.props.dispatch(actions.deleteGeometricElementFile(this.state.deleteGeometricElementFileUuid,
                                () => {
                                    handleTableChange(this.state.currentPage, this.state.currentSize,
                                        this.state.currentSortField, this.state.currentSortOrder);
                                    this.setState({ deleteGeometricElementFileDialogShow: false });
                                },
                                (error) => {
                                    setBackendErrors(error);
                                }))
                        }}
                        setBackendErrors={setBackendErrors}
                    />

                    {/* Export as shape dialog */}
                    <ExportGeometricElementsAsShapeConfirmation
                        modalShow={this.state.showExportModalWindow}
                        onClose={() => { this.setState({ showExportModalWindow: false }) }}
                        id={this.props.geometricElementType.id}
                        code={this.props.geometricElementType.code}
                        empty={this.state.exportEmpty}
                        ownElements={!this.state.exportEmpty && this.state.isMyElementsPage}
                    />

                    {/* Import from shape dialog */}
                    <ImportGeometricElementsFromShape
                        modalShow={this.state.showImportModalWindow}
                        onClose={() => { this.setState({ showImportModalWindow: false }) }}
                        id={this.props.geometricElementType.id}
                    />

                    {/* Table render */}
                    {this.state.geometricElements ? filterPanelRender() : ""}
                    <BootstrapTable
                        bootstrap4
                        keyField="id"
                        columns={columns}
                        data={this.state.geometricElements ?
                            this.state.geometricElements.result.items : []
                        }
                        loading={true}
                        defaultSorted={[{ dataField: 'modificationDate', order: 'desc' }]}
                        expandRow={expandRow}
                        noDataIndication={this.state.geometricElements ?
                            this.props.intl.formatMessage({ id: "project.elements.noElements" },
                                {
                                    plural: getInternationalization(this.props.language, PARAMETER_ELEMENT_TEXT_PLURAL, this.props.allCodes, this.props.activeLanguages)
                                }
                            ) :
                            <div className="spinner-border" role="status">
                                <span className="sr-only"></span>
                            </div>
                        }
                        striped
                        condensed
                        remote
                        rowClasses="text-left"
                        onTableChange={(type, { page, sizePerPage, sortField, sortOrder }) => {
                            handleTableChange(page, sizePerPage, sortField, sortOrder);
                            this.setState({
                                currentPage: page,
                                currentSize: sizePerPage,
                                currentSortField: sortField,
                                currentSortOrder: sortOrder,
                                expandedRows: []
                            });
                        }}
                        pagination={
                            paginationFactory({
                                page: this.state.currentPage,
                                sizePerPage: this.state.currentSize,
                                showTotal: true,
                                hidePageListOnlyOnePage: true,
                                totalSize: this.state.geometricElements ?
                                    this.state.geometricElements.result.totalItems : 0,
                                paginationTotalRenderer: (from, to, size) => {
                                    return <FormattedMessage id="project.common.tables.totalElements"
                                        values={{
                                            from: from,
                                            to: to,
                                            total: size
                                        }
                                        }
                                    />
                                },
                                sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => (
                                    <li
                                        key={text}
                                        role="presentation"
                                        className={`dropdown-item ${this.state.currentSize === Number(text) ? "active" : ""}`}
                                        onMouseDown={(e) => {
                                            e.preventDefault();
                                            onSizePerPageChange(page);
                                        }}
                                        style={{
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {text}
                                    </li>
                                ),
                                nextPageTitle: this.props.intl.formatMessage({ id: 'project.common.pagination.nextPageTitle' }),
                                prePageTitle: this.props.intl.formatMessage({ id: 'project.common.pagination.prePageTitle' }),
                                lastPageTitle: this.props.intl.formatMessage({ id: 'project.common.pagination.lastPageTitle' }),
                                firstPageTitle: this.props.intl.formatMessage({ id: 'project.common.pagination.firstPageTitle' }),
                            })
                        }
                    />
                    <br />
                </div>
            );
        }

        if (!CAN_QUERY_GEOMETRIC_ELEMENTS ||
            (this.state.authenticatedUser && this.state.authenticatedUser.userRoleDto.code !== "ADMIN")
        ) {
            return (
                <div className="container text-center">
                    <br />
                    <div className="card-body alert alert-danger" role="alert">
                        <h4 className="card-text"><FormattedMessage id="project.common.permissionDenied" /></h4>
                    </div>
                </div>
            );
        }

        return (
            null
        );
    }

}

export default withRouter(connect(mapStateToProps)(injectIntl(GeometricElementsByElementType)));